import { LucaBrandHeading } from '@pages/LucaSettingsPage/LucaBrandHeading'
import { SettingsSubPageLayout } from '@pages/SettingsPage/components/SettingsSubPageLayout'
import { LucaUsageSection } from '@root/containers/Stripe/LucaUsageSection/LucaUsageSection'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const LucaUsageSettings: React.FC = () => {
  const [t] = useTranslation()

  return (
    <SettingsSubPageLayout
      title={<LucaBrandHeading>{t('settings.billing.lucaUsage.title')}</LucaBrandHeading>}
      contentPadding="none"
    >
      <Body>
        <LucaUsageSection />
      </Body>
    </SettingsSubPageLayout>
  )
}

// Header inset is spacing.lg; the shared settings body inset is spacing.md.
const Body = styled.div`
  padding: ${({ theme }) => `${theme.spacing.md}rem ${theme.spacing.lg}rem`};
`
